import {useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {getSwimlane, saveSwimlane} from "../services/api";

export function EditSwimlane() {
    const { swimlaneId } = useParams()
    
    const [swimlane, setSwimlane] = useState({})
    const navigate = useNavigate()
    
    useEffect(() => {
        const fetchData = async() => {
            try {
                if (swimlaneId !== "new") {
                    const data = await getSwimlane(swimlaneId)
                    setSwimlane(data)
                }
            } catch(ex) {
                console.log(ex)
            }
        }
        
        fetchData()
            .catch(console.error)

    }, [])
    
    const updateName = (event) => {
        setSwimlane({
            ...swimlane,
            name: event.target.value
        })
    }
    
    const updateWeeklyBudget = (event) => {
        console.log("Event value: ", event.target.value)
        setSwimlane({
            ...swimlane,
            weeklyBudget: event.target.value
        })
    }
    
    const updateCurrentSavings = (event) => {
        setSwimlane({
            ...swimlane,
            currentSavings: event.target.value
        })
    }
    
    const submit = async(event)=> {
        event.preventDefault()
        
        try {
            await saveSwimlane(swimlane)
            navigate("/wants")
        } catch(ex) {
            console.log("Error saving wants: ", ex)
        }
    }
    
    return (
        <>
            <form onSubmit={submit}>
                <div className="form-group mb-3">
                    <label>Name</label>
                    <input type="text" className="form-control" value={swimlane.name} onChange={updateName}/>
                </div>
                <div className="form-group mb-3">
                    <label>Weekly Budget</label>
                    <input type="text" className="form-control" value={swimlane.weeklyBudget}
                           onChange={updateWeeklyBudget}/>
                </div>
                <div className="form-group mb-3">
                    <label>Current Savings</label>
                    <input type="text" className="form-control" value={swimlane.currentSavings}
                           onChange={updateCurrentSavings}/>
                </div>
                <div className="form-group">
                    <button className="btn btn-primary">Submit</button>
                </div>
            </form>
        </>
    )
}